import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/wait"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85912 2.06735C8.47134 1.41635 7.52861 1.41635 7.14084 2.06736L0.337955 13.4883C-0.0590912 14.1548 0.421226 15 1.19709 15H14.8029C15.5787 15 16.0591 14.1548 15.662 13.4883L8.85912 2.06735ZM8.99998 5.00001H6.99998V11H8.99998V5.00001ZM7.99998 14C8.55226 14 8.99998 13.5523 8.99998 13C8.99998 12.4477 8.55226 12 7.99998 12C7.44769 12 6.99998 12.4477 6.99998 13C6.99998 13.5523 7.44769 14 7.99998 14Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Wait16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Wait16 = createIcon(IconComponent);